module.exports = __webpack_public_path__ + "img/portrait-051.07e36b39.jpg";